(function(){
  function enhance(root=document){
    root.querySelectorAll('.pv:not([data-pv-ready])').forEach((wrap)=>{
      wrap.setAttribute('data-pv-ready','1');

      const src    = wrap.getAttribute('data-src')    || '';
      const poster = wrap.getAttribute('data-poster') || '';
      const aspect = wrap.getAttribute('data-aspect') || '1/1';

      // Reuse or create <video>
      let video = wrap.querySelector('video');
      if (!video) {
        video = document.createElement('video');
        wrap.appendChild(video);
      }
      video.classList.add('pv-media');
      video.setAttribute('playsinline','');
      video.setAttribute('preload','metadata');
      if (src)    video.src = src;
      if (poster) video.setAttribute('poster', poster);
      wrap.style.setProperty('--pv-aspect', aspect);
      // Inline aspect for older browsers that ignore custom prop on child
      try { video.style.aspectRatio = aspect; } catch(e){}

      // Reuse or create controls
      let playBtn  = wrap.querySelector('.pv-play');
      let pauseBtn = wrap.querySelector('.pv-pause');
      if (!playBtn) {
        playBtn = document.createElement('button');
        playBtn.className = 'pv-ctrl pv-play';
        playBtn.type = 'button';
        playBtn.setAttribute('aria-label','Play');
        playBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 7l8 5-8 5V7z" fill="currentColor"/></svg>';
        wrap.appendChild(playBtn);
      }
      if (!pauseBtn) {
        pauseBtn = document.createElement('button');
        pauseBtn.className = 'pv-ctrl pv-pause';
        pauseBtn.type = 'button';
        pauseBtn.setAttribute('aria-label','Pause');
        pauseBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 7h3v10H8V7zm5 0h3v10h-3V7z" fill="currentColor"/></svg>';
        pauseBtn.hidden = true;
        wrap.appendChild(pauseBtn);
      }

      const showPlay  = ()=>{ playBtn.hidden = false; pauseBtn.hidden = true; };
      const showPause = ()=>{ playBtn.hidden = true;  pauseBtn.hidden = false; };
      const play  = ()=> video.play().then(showPause).catch(showPlay);
      const pause = ()=> { video.pause(); showPlay(); };
      const toggle= ()=> video.paused ? play() : pause();

      // Remove old listeners if re-enhancing
      wrap._pvCleanup?.();

      playBtn.addEventListener('click', play);
      pauseBtn.addEventListener('click', pause);
      video.addEventListener('click', toggle);
      video.addEventListener('play',  showPause);
      video.addEventListener('pause', showPlay);
      video.addEventListener('ended', showPlay);
      const onKey = (e)=>{ if (e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); toggle(); } };
      playBtn.addEventListener('keydown', onKey);
      pauseBtn.addEventListener('keydown', onKey);
      const onVis = ()=>{ if (document.hidden && !video.paused) pause(); };
      document.addEventListener('visibilitychange', onVis);

      wrap._pvCleanup = ()=> {
        playBtn.removeEventListener('click', play);
        pauseBtn.removeEventListener('click', pause);
        video.removeEventListener('click', toggle);
        video.removeEventListener('play',  showPause);
        video.removeEventListener('pause', showPlay);
        video.removeEventListener('ended', showPlay);
        playBtn.removeEventListener('keydown', onKey);
        pauseBtn.removeEventListener('keydown', onKey);
        document.removeEventListener('visibilitychange', onVis);
      };
    });
  }

  // Expose globally and auto-run on DOMReady
  window.enhancePlayableVideos = enhance;
  if (document.readyState !== 'loading') enhance();
  else document.addEventListener('DOMContentLoaded', ()=>enhance());
})();

